import { connect } from "react-redux";
import Price from "./Price";
import { getStoreCode, getCurrencyId } from "../../state/modules/regionalStore";

const mapStateToProps = state => ({
  currencyId: getCurrencyId(state),
  storeCode: getStoreCode(state)
});

export default connect(mapStateToProps)(Price);



// WEBPACK FOOTER //
// ./template/components/Price/index.js